/* tslint:disable */
/* eslint-disable */
/**
 * IbanOplata.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { IbanAccountAddCommand } from '../models';
// @ts-ignore
import type { IbanAccountResponseDto } from '../models';
// @ts-ignore
import type { IbanAccountUpdateCommand } from '../models';
// @ts-ignore
import type { ProblemDetails } from '../models';
/**
 * IbanAccountApi - axios parameter creator
 * @export
 */
export const IbanAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountIbanAccountUidDelete: async (ibanAccountUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanAccountUid' is not null or undefined
            assertParamExists('apiIbanAccountIbanAccountUidDelete', 'ibanAccountUid', ibanAccountUid)
            const localVarPath = `/api/iban-account/{ibanAccountUid}`
                .replace(`{${"ibanAccountUid"}}`, encodeURIComponent(String(ibanAccountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountIbanAccountUidGet: async (ibanAccountUid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ibanAccountUid' is not null or undefined
            assertParamExists('apiIbanAccountIbanAccountUidGet', 'ibanAccountUid', ibanAccountUid)
            const localVarPath = `/api/iban-account/{ibanAccountUid}`
                .replace(`{${"ibanAccountUid"}}`, encodeURIComponent(String(ibanAccountUid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanAccountAddCommand} [ibanAccountAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountPost: async (ibanAccountAddCommand?: IbanAccountAddCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanAccountAddCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {IbanAccountUpdateCommand} [ibanAccountUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountPut: async (ibanAccountUpdateCommand?: IbanAccountUpdateCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/iban-account`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ibanAccountUpdateCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IbanAccountApi - functional programming interface
 * @export
 */
export const IbanAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IbanAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanAccountGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<IbanAccountResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanAccountGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanAccountApi.apiIbanAccountGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanAccountIbanAccountUidDelete(ibanAccountUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanAccountIbanAccountUidDelete(ibanAccountUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanAccountApi.apiIbanAccountIbanAccountUidDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanAccountIbanAccountUidGet(ibanAccountUid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanAccountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanAccountIbanAccountUidGet(ibanAccountUid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanAccountApi.apiIbanAccountIbanAccountUidGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanAccountAddCommand} [ibanAccountAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanAccountPost(ibanAccountAddCommand?: IbanAccountAddCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanAccountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanAccountPost(ibanAccountAddCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanAccountApi.apiIbanAccountPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {IbanAccountUpdateCommand} [ibanAccountUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIbanAccountPut(ibanAccountUpdateCommand?: IbanAccountUpdateCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IbanAccountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIbanAccountPut(ibanAccountUpdateCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IbanAccountApi.apiIbanAccountPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IbanAccountApi - factory interface
 * @export
 */
export const IbanAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IbanAccountApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<IbanAccountResponseDto>> {
            return localVarFp.apiIbanAccountGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountIbanAccountUidDelete(ibanAccountUid: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIbanAccountIbanAccountUidDelete(ibanAccountUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} ibanAccountUid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountIbanAccountUidGet(ibanAccountUid: string, options?: RawAxiosRequestConfig): AxiosPromise<IbanAccountResponseDto> {
            return localVarFp.apiIbanAccountIbanAccountUidGet(ibanAccountUid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanAccountAddCommand} [ibanAccountAddCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountPost(ibanAccountAddCommand?: IbanAccountAddCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanAccountResponseDto> {
            return localVarFp.apiIbanAccountPost(ibanAccountAddCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {IbanAccountUpdateCommand} [ibanAccountUpdateCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIbanAccountPut(ibanAccountUpdateCommand?: IbanAccountUpdateCommand, options?: RawAxiosRequestConfig): AxiosPromise<IbanAccountResponseDto> {
            return localVarFp.apiIbanAccountPut(ibanAccountUpdateCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IbanAccountApi - object-oriented interface
 * @export
 * @class IbanAccountApi
 * @extends {BaseAPI}
 */
export class IbanAccountApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanAccountApi
     */
    public apiIbanAccountGet(options?: RawAxiosRequestConfig) {
        return IbanAccountApiFp(this.configuration).apiIbanAccountGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ibanAccountUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanAccountApi
     */
    public apiIbanAccountIbanAccountUidDelete(ibanAccountUid: string, options?: RawAxiosRequestConfig) {
        return IbanAccountApiFp(this.configuration).apiIbanAccountIbanAccountUidDelete(ibanAccountUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} ibanAccountUid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanAccountApi
     */
    public apiIbanAccountIbanAccountUidGet(ibanAccountUid: string, options?: RawAxiosRequestConfig) {
        return IbanAccountApiFp(this.configuration).apiIbanAccountIbanAccountUidGet(ibanAccountUid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanAccountAddCommand} [ibanAccountAddCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanAccountApi
     */
    public apiIbanAccountPost(ibanAccountAddCommand?: IbanAccountAddCommand, options?: RawAxiosRequestConfig) {
        return IbanAccountApiFp(this.configuration).apiIbanAccountPost(ibanAccountAddCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {IbanAccountUpdateCommand} [ibanAccountUpdateCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IbanAccountApi
     */
    public apiIbanAccountPut(ibanAccountUpdateCommand?: IbanAccountUpdateCommand, options?: RawAxiosRequestConfig) {
        return IbanAccountApiFp(this.configuration).apiIbanAccountPut(ibanAccountUpdateCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

